import React from 'react';
import ProjectLayout from '../Components/ProjectLayout';

import billboardVideo from '../assets/projects/evo-agency/billboard.mp4';
import scaleConverEvolveVideo from '../assets/projects/evo-agency/scale-conver-evolve.mp4';
import laptopImg from '../assets/projects/evo-agency/laptop.webp';
import iphoneImg from '../assets/projects/evo-agency/iphone.webp';

const Evosite = () => {
  return (
    <ProjectLayout
      title="Evo Agency"
      description={[
        'I teamed up with Evo Agency to craft a dynamic animation for their brand overhaul, working directly with the CEO and lead designer.',
        "From storyboarding to 3D animation, post-production to editing, I created a video that captured the essence of Evo Agency's new, all-encompassing approach to ecommerce.",
      ]}
      credits={['Storyboarding', '3D Animation', 'Post-production']}
    >
      <div className="pm-video">
        <video autoPlay muted loop playsInline preload="auto">
          <source src="/videos/evo-agency.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>

      <video
        className="pm-full"
        src={billboardVideo}
        autoPlay
        muted
        loop
        playsInline
        preload="metadata"
        aria-label="Evo Agency billboard animation"
      />

      <div className="pm-row">
        <video
          src={scaleConverEvolveVideo}
          autoPlay
          muted
          loop
          playsInline
          preload="metadata"
          aria-label="Scale Conver Evolve animation"
        />
        <img src={laptopImg} alt="Evo Agency website on laptop" />
      </div>

      <img className="pm-full" src={iphoneImg} alt="Evo Agency website on iPhone" />
    </ProjectLayout>
  );
};

export default Evosite;
